<template>
  <div>
		<div class="csBox">
			<div class="container">
			  <img :src="item.img" class="img" :style="{
				  '--img':(index*70+item.left)+'px'
			  }" v-for="(item,index) in list" :key="index" @mouseenter="mouseover(index)" @mouseleave="mouseout">
			</div>
			<div class="csBoxRight">
				{{itema.name}}
			</div>
		</div>
  </div>
</template>

<script>
  export default {
    components: {
	
    },
    data() {
      return {
		list:[
			{
				img:'https://aohuacbi.oss-cn-qingdao.aliyuncs.com/20230412/banner%20%E5%A4%A7%E5%B0%8F%403x%20(1).png',
				name:'1',
				left:0,
			},
			{
				img:'https://aohuacbi.oss-cn-qingdao.aliyuncs.com/20230418/%E7%9F%A9%E5%BD%A2%208%403x.png',
				name:'2',
				left:0,
			},
			{
				img:'https://aohuacbi.oss-cn-qingdao.aliyuncs.com/20230412/banner%20%E5%A4%A7%E5%B0%8F%403x%20(1).png',
				name:'3',
				left:0,
			},
			{
				img:'https://aohuacbi.oss-cn-qingdao.aliyuncs.com/20230418/%E7%9F%A9%E5%BD%A2%208%403x.png',
				name:'4',
				left:0,
			},
			{
				img:'https://aohuacbi.oss-cn-qingdao.aliyuncs.com/20230412/banner%20%E5%A4%A7%E5%B0%8F%403x%20(1).png',
				name:'5',
				left:0,
			},
			{
				img:'https://aohuacbi.oss-cn-qingdao.aliyuncs.com/20230418/%E7%9F%A9%E5%BD%A2%208%403x.png',
				name:'6',
				left:0,
			},
		],
		itema:{
			
		}
      }
    },
    mounted() {

    },
    methods: {
		mouseout(){
			this.list.map(v=>{
				v.left=0;
			})
		},
		mouseover(e){
			console.log(e)
			this.list.map((v,a)=>{
				if(e>a){
					v.left=0;
				}else if(e<a){
					v.left=80;
				}
			})
			this.itema=this.list[e]
			console.log(this.list)
		}
    }
  }
</script>

<style>

</style>
<style scoped lang="scss">
	.csBox{
		display: flex;
		justify-content: space-between;
		width: 100%;
		height: 500px;
		.container {
			position: relative;
			transform-style: preserve-3d;
			transform: perspective(1000px);
			background-color: #000;
			 perspective: 1000px;
			 height:500px;
			img{
				position: absolute;
				top:100px;
				left: 0;
				transform-style: preserve-3d;
				transform:perspective(1000px)  rotateY(30deg)  scale(0.8) ;
				width: 300px;
				height: 300px;
				transition: all .6s ease;
			}
			img{
				left: var(--img);
			}
			img:hover{
				transform:rotateY(15deg) scale(0.9);
				z-index: 999;
			}
		}
		.csBoxRight{
			width: 300px;
			height: 500px;
			display: flex;
			align-items: center;
		}
	}
	// transform: translateX(12.8075px
	// ) translateZ(-20.4213px
	// ) rotateY(
	// 33.75deg
	// );
</style>
